import React from "react";
import TransactionItem from "../../containerSmall/transactionItem/transactionItem.component";

const TransactionList = ({ transList }) => {
  // console.log(transList);
  return (
    <div style={{ height: "100%", overflowY: "auto", scrollbarWidth: "thin" }}>
      {transList?.map((item) => (
        <TransactionItem key={item.id} {...item} />
      ))}
    </div>
  );
};

export default TransactionList;
